export * from './domain';
export * from './testkit';
export * from './builders';
export * from './dto';
export var agentStatsUrl = '/agent/stats';
export var createChatDashboardApi = function (baseUrl, http) {
    var url = baseUrl + "/dashboard/chat";
    return {
        getTableData: function (chatDashboardDto) { return http.post("" + url, chatDashboardDto); },
        getDashboardOverview: function (chatDashboardOverviewDto) { return http.post(url + "/overview", chatDashboardOverviewDto); },
        getAgentStats: function (chatDashboardBaseDto) { return http.post("" + url + agentStatsUrl, chatDashboardBaseDto); },
    };
};
//# sourceMappingURL=index.js.map